import { motion, useReducedMotion } from "motion/react";
import type { ComponentPropsWithoutRef } from "react";

import { EASE_OUT_STRONG } from "./constants";

/**
 * Stagger child with a subtle fade-up entrance.
 * Must be a direct child of AnimatedContainer for stagger timing to apply.
 * Pass initial="hidden" animate="visible" when used standalone.
 */
export function AnimatedItem(
  props: ComponentPropsWithoutRef<typeof motion.div>,
) {
  const shouldReduceMotion = useReducedMotion();

  const variants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0 : 0.24,
        ease: EASE_OUT_STRONG,
      },
    },
  };

  return <motion.div variants={variants} {...props} />;
}
